import axios from "axios";
import {ZapleczeApi} from "../ZapleczeApi.ts";
import Profile from "../Model/Profile.ts";


export interface OperationContactSave {
    id: number;
    tmpId: number;
    type: string;
    status: string;
    message: string;
}

export interface OperationContactRec {
    id: number;
    role: string[];
    name: string;
    phone: string;
    email: string;
    description: string;
}

export interface ContactRole {
    [key: string]: string;
}

export class OperationContactApi extends ZapleczeApi {

    public constructor(token: string, profile: Profile) {
        super(token, profile);
    }

    public async remove(contactsIds: number[]): Promise<OperationContactSave[]> {
        console.log("Deleteing operation contacts:", contactsIds);
        const url = this.getUrl() + '/api/v2/profile/' + this.getProfile().getId() + '/contacts';
        try {
            const response = await axios.delete<OperationContactSave[]>(url, {
                headers: {
                    'Authorization': this.getBearer(),
                },
                data: contactsIds
            });
            console.log(response.data);
            return response.data;
        } catch (e) {
            console.error(e);
            return [];
        }
    }

    public async save(contacts: OperationContactRec[]): Promise<OperationContactSave[]> {
        console.log("Saving operation contacts:", contacts);
        const url = this.getUrl() + '/api/v2/profile/' + this.getProfile().getId() + '/contacts';
        try {
            const response = await axios.post<OperationContactSave[]>(url, contacts, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.getBearer(),
                },
            });
            console.log(response.data);
            return response.data;
        } catch (e) {
            console.error(e);
            return [];
        }
    }

    public async update(toSave: OperationContactRec[], toRemove: number[]): Promise<OperationContactSave[]> {
        try {
            const [deletedResults, savedResults] = await Promise.all([
                this.remove(toRemove),
                this.save(toSave)
            ]);

            return [...deletedResults, ...savedResults];
        } catch (e) {
            console.error("Combined operation failed:", e);
            return [];
        }
    }

    public async contactList(): Promise<OperationContactRec[]> {
        const url = this.getUrl() + '/api/v2/profile/' + this.getProfile().getId() + '/contact-list';

        try {
            const response = await axios.get<OperationContactRec[]>(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.getBearer(),
                },
            });
            console.log(response.data);
            return response.data;
        } catch (e) {
            console.error(e);
            return [];
        }
    }

    public async contactRole(): Promise<ContactRole> {
        const url = this.getUrl() + '/api/v2/profile/contact-role';

        try {
            const response = await axios.get<ContactRole>(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.getBearer(),
                },
            });
            console.log(response.data);
            return response.data;
        } catch (e) {
            console.error(e);
            return {}
        }
    }

}